<template>
  <section id="support" class="spacer tight half">
     <collapse
        :uid="support.uid"
        :fold="true"
        parent="support"
      >
        <template v-slot:header>
          <div class="first">{{ support.title }}</div>
        </template>
        <template v-slot:content>
           <div class="" v-html="support.textarea"></div>
        </template>
      </collapse>
  </section>
</template>

<script>
import Collapse from "@/components/Collapse.vue";
import API from "@/api/service";
export default {
  components: {
    Collapse
  },
  data() {
    return {
      support: []
    };
  },
  created() {
    API.support(this.$i18n.locale).then(page => {
      this.support = page.data.result;
    });
  }
};
</script>

<style></style>
